/**
 * Hero section interactions
 * Smooth scroll handling for hero scroll indicator
 */

document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero');
  if (!hero) {
    return;
  }

  const scrollLink = hero.querySelector('.hero__scroll');
  if (!scrollLink) {
    return;
  }

  const handleScrollClick = (e) => {
    const href = scrollLink.getAttribute('href');
    if (!href || !href.startsWith('#')) {
      return;
    }

    const targetId = href.slice(1);
    const targetElement = document.getElementById(targetId) || document.querySelector(href);

    if (targetElement) {
      e.preventDefault();

      const header = document.querySelector('.header') || document.querySelector('.page-header');
      const headerOffset = header ? header.offsetHeight : 0;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = Math.max(0, elementPosition - headerOffset);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', href);
      }
    }
  };

  scrollLink.addEventListener('click', handleScrollClick);
  scrollLink.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleScrollClick(e);
    }
  });
});
